import React, { useState, useMemo, Fragment } from 'react';
import Traductor from '../Traductor';
import {
    filterAgrupations,
    filterBrands,
    filterModels,
    filterKm,
    filterTransmission,
    filterEnergies,
    filterZones,
    filterPowerMax,
    filterPriceMax,
    filterFavorite,
    filterBidden,
    filterPlate,
    filterRegistrationDate,
    filterStates,
    filterBuyer,
    filterDatePurchaseFrom,
    filterDatePurchaseTo,
    filterYearPurchase,
    filterMonthPurchase,
    filterComercialProducts,
    filterDealers,
    filterVIN,
    filterDatePurchaseOptionFrom,
    filterDatePurchaseOptionTo,
    filterWarrantyExtension,
    filterFinancialOperation,
    filterTransportState,
} from '../../constants/Filters';

import { checkInitFilterValues } from '../../js/filterFunctions';
import Tag from '../../components/bronson/Tag';

function TagFilters({ refreshFilters, filters, filtersOptions, resetFilters }) {
    const t = useMemo(() => new Traductor(), []);
    const [showAllTags, setShowAllTags] = useState(false);
    const filtersCodes = [
        {
            code: filterFavorite,
            name: t.getTraduction('Favourits'),
            type: 'Toggle',
        },
        {
            code: filterBidden,
            name: t.getTraduction('Bids'),
            type: 'Toggle',
        },
        {
            code: filterAgrupations,
            name: 'Agrupations',
            type: 'List',
        },
        {
            code: filterBrands,
            name: 'Brands',
            type: 'List',
        },
        {
            code: filterModels,
            name: 'Models',
            type: 'List',
        },
        {
            code: filterKm,
            name: 'Km',
            symbol: 'Km',
            type: 'Range',
        },
        {
            code: filterTransmission,
            name: 'Transmission',
            type: 'List',
        },
        {
            code: filterEnergies,
            name: 'Energies',
            type: 'List',
        },
        {
            code: filterZones,
            name: 'Zones',
            type: 'List',
        },
        {
            code: filterPowerMax,
            name: 'PowerMax',
            symbol: 'CV',
            type: 'Range',
        },
        {
            code: filterPriceMax,
            name: 'PriceMax',
            symbol: '€',
            type: 'Range',
        },
        {
            code: filterRegistrationDate,
            name: 'RegistrationDate',
            symbol: '',
            type: 'Range',
        },
        {
            code: filterPlate,
            name: t.getTraduction('Plate'),
            type: 'Input',
        },
        {
            code: filterBuyer,
            name: 'Buyers',
            type: 'List',
        },
        {
            code: filterStates,
            name: 'States',
            type: 'List',
        },
        {
            code: filterTransportState,
            name: 'Transports',
            type: 'List',
        },
        {
            code: filterDatePurchaseFrom,
            name: t.getTraduction('Desde'),
            type: 'Datepicker',
        },
        {
            code: filterDatePurchaseTo,
            name: t.getTraduction('Hasta'),
            type: 'Datepicker',
        },
        {
            code: filterYearPurchase,
            name: 'YearPurchase',
            symbol: '',
            type: 'Range',
        },
        {
            code: filterMonthPurchase,
            name: '',
            type: 'Select',
        },
        {
            code: filterComercialProducts,
            name: 'Products',
            type: 'List',
        },
        {
            code: filterDealers,
            name: 'Dealers',
            type: 'List',
        },
        {
            code: filterVIN,
            name: t.getTraduction('VIN'),
            type: 'Input',
        },
        {
            code: filterDatePurchaseOptionFrom,
            name: t.getTraduction('Desde'),
            type: 'Datepicker',
        },
        {
            code: filterDatePurchaseOptionTo,
            name: t.getTraduction('Hasta'),
            type: 'Datepicker',
        },
        {
            code: filterWarrantyExtension,
            name: t.getTraduction('WithValidWarrantyExtension'),
            type: 'Toggle',
        },
        {
            code: filterFinancialOperation,
            name: t.getTraduction('FinancialOperation'),
            type: 'Input',
        },
    ];

    const getNumberWithDots = number => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const setNewIntegerFilter = (value, code, tagsShowing, maxNumberTags) => {
        refreshFilters({ ...filters, [code]: value });
        checkTagsInViewSeeMinus(tagsShowing, maxNumberTags);
    };

    const setNewRangeFilter = (value, code, tagsShowing, maxNumberTags) => {
        refreshFilters({ ...filters, [code]: value });
        checkTagsInViewSeeMinus(tagsShowing, maxNumberTags);
    };

    const setNewMultiselectFilter = (
        idValue,
        code,
        tagsShowing,
        maxNumberTags
    ) => {
        let key = filters[code].indexOf(idValue);
        let newFilterValues = [];
        if (key > -1) {
            newFilterValues = filters[code].filter(function (e) {
                return e !== idValue;
            });
        }
        let newfilters = { ...filters, [code]: newFilterValues };

        if (code == filterBrands)
            newfilters = { ...newfilters, [filterModels]: [] };

        refreshFilters(newfilters);
        checkTagsInViewSeeMinus(tagsShowing, maxNumberTags);
    };

    const checkTagsInViewSeeMinus = (tagsShowing, maxNumberTags) => {
        if (tagsShowing - 1 <= maxNumberTags) {
            setShowAllTags(false);
        }
    };

    const printlistTags = () => {
        let maxNumberTags = 0;
        let extraNumberTags = 0;
        let tagsShowing = 0;
        let permisionToShow = false;

        let windowWidth = document.getElementById('TagFiltersList')
            ? document.getElementById('TagFiltersList').offsetWidth
            : 0;
        let listTags = [];

        if (windowWidth > 650) {
            maxNumberTags = 3;
        } else {
            maxNumberTags = 2;
        }

        filtersCodes &&
            filtersCodes.map((element, index) => {
                permisionToShow = tagsShowing < maxNumberTags || showAllTags;

                if (filters[element.code]) {
                    switch (element.type) {
                        case 'Toggle':
                            if (filters[element.code] == true) {
                                if (permisionToShow) {
                                    listTags.push(
                                        <li
                                            key={`${index}${element.code}${element.name}`}
                                        >
                                            <span
                                                className="c-tag"
                                                key={
                                                    'tagFilter_' +
                                                    element.code +
                                                    '_' +
                                                    index
                                                }
                                            >
                                                <span className="c-tag__label">
                                                    {
                                                        element.name /* Translate */
                                                    }
                                                </span>
                                                {refreshFilters && (
                                                    <button
                                                        className="c-tag__close"
                                                        title="Close"
                                                        type="button"
                                                        onClick={e =>
                                                            setNewIntegerFilter(
                                                                false,
                                                                element.code,
                                                                tagsShowing,
                                                                maxNumberTags
                                                            )
                                                        }
                                                    />
                                                )}
                                            </span>
                                        </li>
                                    );
                                    tagsShowing++;
                                } else {
                                    extraNumberTags++;
                                }
                            }
                            break;
                        case 'List':
                            if (
                                filters[element.code] &&
                                filters[element.code].length > 0 &&
                                filtersOptions[element.name] &&
                                filtersOptions[element.name].length > 0
                            ) {
                                filtersOptions[element.name].map(
                                    (item, index_list) => {
                                        if (
                                            filters[element.code].indexOf(
                                                item.Id
                                            ) > -1
                                        ) {
                                            if (permisionToShow) {
                                                listTags.push(
                                                    <li
                                                        key={`${index}${element.code}${item.Description}`}
                                                    >
                                                        <span
                                                            className={
                                                                'c-tag ' +
                                                                (item
                                                                    .Description
                                                                    .length > 20
                                                                    ? 'c-tag-filter--large'
                                                                    : '')
                                                            }
                                                            key={
                                                                'tagFilter_' +
                                                                element.code +
                                                                '_' +
                                                                index_list +
                                                                '_' +
                                                                item.Id
                                                            }
                                                        >
                                                            <span className="c-tag__label">
                                                                {item
                                                                    .Description
                                                                    .length >
                                                                20 ? (
                                                                    <abbr
                                                                        title={
                                                                            item.Description
                                                                        }
                                                                    >
                                                                        {
                                                                            item.Description
                                                                        }
                                                                    </abbr>
                                                                ) : (
                                                                    item.Description
                                                                )}
                                                            </span>
                                                            {refreshFilters && (
                                                                <button
                                                                    className="c-tag__close"
                                                                    title="Close"
                                                                    type="button"
                                                                    onClick={e =>
                                                                        setNewMultiselectFilter(
                                                                            item.Id,
                                                                            element.code,
                                                                            tagsShowing,
                                                                            maxNumberTags
                                                                        )
                                                                    }
                                                                />
                                                            )}
                                                        </span>
                                                    </li>
                                                );
                                                tagsShowing++;
                                            } else {
                                                extraNumberTags++;
                                            }
                                        }
                                    }
                                );
                            }
                            break;
                        case 'Range':
                            let resetValueFilters = checkInitFilterValues(
                                element.code,
                                filters,
                                filtersOptions
                            );
                            if (
                                filters[element.code].length > 0 &&
                                resetValueFilters != null
                            ) {
                                if (permisionToShow) {
                                    listTags.push(
                                        <li
                                            key={`${index}${element.code}${element.symbol}`}
                                        >
                                            <span
                                                className="c-tag"
                                                key={
                                                    'tagFilter_' +
                                                    element.code +
                                                    '_' +
                                                    index
                                                }
                                            >
                                                {element.code ==
                                                    filterRegistrationDate ||
                                                element.code ==
                                                    filterYearPurchase ? (
                                                    <span className="c-tag__label">
                                                        {filters[
                                                            element.code
                                                        ][0] +
                                                            element.symbol +
                                                            ' - ' +
                                                            filters[
                                                                element.code
                                                            ][1] +
                                                            element.symbol}
                                                    </span>
                                                ) : (
                                                    <span className="c-tag__label">
                                                        {getNumberWithDots(
                                                            filters[
                                                                element.code
                                                            ][0]
                                                        ) +
                                                            element.symbol +
                                                            ' - ' +
                                                            getNumberWithDots(
                                                                filters[
                                                                    element.code
                                                                ][1]
                                                            ) +
                                                            element.symbol}
                                                    </span>
                                                )}
                                                {refreshFilters && (
                                                    <button
                                                        className="c-tag__close"
                                                        title="Close"
                                                        type="button"
                                                        onClick={e =>
                                                            setNewRangeFilter(
                                                                resetValueFilters,
                                                                element.code,
                                                                tagsShowing,
                                                                maxNumberTags
                                                            )
                                                        }
                                                    />
                                                )}
                                            </span>
                                        </li>
                                    );
                                    tagsShowing++;
                                } else {
                                    extraNumberTags++;
                                }
                            }
                            break;
                        case 'Datepicker':
                        case 'Input':
                            if (
                                filters[element.code] != '' &&
                                filters[element.code] != null
                            ) {
                                if (permisionToShow) {
                                    let text =
                                        element.name +
                                        ': ' +
                                        filters[element.code];
                                    listTags.push(
                                        <li
                                            key={`${index}${element.code}${text}`}
                                        >
                                            <span
                                                className="c-tag"
                                                key={
                                                    'tagFilter_' +
                                                    element.code +
                                                    '_' +
                                                    index
                                                }
                                            >
                                                <span className="c-tag__label">
                                                    {text}
                                                </span>
                                                {refreshFilters && (
                                                    <button
                                                        className="c-tag__close"
                                                        title="Close"
                                                        type="button"
                                                        onClick={e =>
                                                            setNewIntegerFilter(
                                                                null,
                                                                element.code,
                                                                tagsShowing,
                                                                maxNumberTags
                                                            )
                                                        }
                                                    />
                                                )}
                                            </span>
                                        </li>
                                    );
                                    tagsShowing++;
                                } else {
                                    extraNumberTags++;
                                }
                            }
                            break;
                        case 'Select':
                            if (filters[element.code] != '') {
                                if (
                                    permisionToShow &&
                                    filters[element.code] > 0
                                ) {
                                    let text = element.code;
                                    switch (element.code) {
                                        case filterMonthPurchase:
                                            text =
                                                filtersOptions.Months[
                                                    filters[element.code]
                                                ].NameMonth;
                                            break;
                                        default:
                                            break;
                                    }

                                    listTags.push(
                                        <li
                                            key={`${index}${element.code}${text}`}
                                        >
                                            <span
                                                className="c-tag"
                                                key={
                                                    'tagFilter_' +
                                                    element.code +
                                                    '_' +
                                                    index
                                                }
                                            >
                                                <span className="c-tag__label">
                                                    {text}
                                                </span>
                                                {refreshFilters && (
                                                    <button
                                                        className="c-tag__close"
                                                        title="Close"
                                                        type="button"
                                                        onClick={e =>
                                                            setNewIntegerFilter(
                                                                '',
                                                                element.code,
                                                                tagsShowing,
                                                                maxNumberTags
                                                            )
                                                        }
                                                    />
                                                )}
                                            </span>
                                        </li>
                                    );
                                    tagsShowing++;
                                } else {
                                    extraNumberTags++;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        if (tagsShowing > 0 && extraNumberTags > 0 && !showAllTags) {
            listTags.push(
                <li key={`${listTags.length}-view-all`}>
                    <Tag
                        classes={['flat']}
                        text={t.getTraduction('ViewAll')}
                        type="button"
                        clickFunction={e => setShowAllTags(true)}
                    ></Tag>
                </li>
            );
        } else {
            if (showAllTags && tagsShowing > 0) {
                listTags.push(
                    <li key={`${listTags.length}-view-less`}>
                        <Tag
                            classes={['flat']}
                            text={t.getTraduction('ViewLess')}
                            type="button"
                            clickFunction={e => setShowAllTags(false)}
                        ></Tag>
                    </li>
                );
            }
        }

        if (tagsShowing > 0 && tagsShowing >= 2 && windowWidth > 0) {
            listTags.push(
                <li key={`${listTags.length}-reset`}>
                    <Tag
                        classes={['flat']}
                        text={t.getTraduction('ResetFilters')}
                        type="button"
                        clickFunction={resetFilters}
                    ></Tag>
                </li>
            );
        }

        return listTags;
    };

    return <Fragment>{printlistTags()}</Fragment>;
}

export default TagFilters;
